<template>
  <div class="tournament-branding">
    <div class="branding-layout">
      <!-- LEFT -->

      <div class="info-cards">
        <!-- LIGHT CARD -->
        <div class="info-card info-card--light">
          <!-- Partner Logo (Light) -->
          <div class="section">
            <div class="section-title-row">
              <v-icon small class="mr-2">fa-regular fa-palette</v-icon>
              <span class="section-title">{{ $t("appearance") }} (Light)</span>
            </div>
            <div class="upload-dropzone">
              <div
                class="upload-content"
                @dragover.prevent
                @dragenter.prevent="onDragEnter('LIGHT')"
                @dragleave.prevent="onDragLeave('LIGHT')"
                @drop.prevent="onDrop($event, 'LIGHT')"
                :class="{ dragging: isDraggingLight }"
              >
                <div v-if="imagePreviewLight" class="preview-column">
                  <v-img
                    :src="imagePreviewLight"
                    max-height="80"
                    max-width="180"
                    contain
                    class="preview-img"
                  />
                  <v-btn
                    text
                    small
                    class="remove-btn"
                    @click.stop="removeImage('LIGHT')"
                  >
                    <v-icon small class="mr-1">fa-regular fa-trash</v-icon>
                    {{ $t("remove") }}
                  </v-btn>
                </div>

                <div v-else class="upload-empty">
                  <v-icon size="28" class="mr-2"
                    >fa-regular fa-cloud-arrow-up</v-icon
                  >
                  <div class="upload-text">
                    <div class="upload-title">{{ $t("uploadImage") }}</div>
                    <div class="upload-subtitle">
                      {{ $t("dragDropSelectText") }}
                    </div>
                    <div class="upload-hint">Max: 2MB · JPG/PNG/SVG</div>
                  </div>
                </div>

                <ImageInput
                  v-model="partnerLogoLight"
                  @input="(v) => handleImageChange(v, 'LIGHT')"
                >
                  <div slot="activator">
                    <v-btn class="browse-btn" depressed>
                      <v-icon small class="mr-2"
                        >fa-regular fa-folder-open</v-icon
                      >
                      {{ $t("browseFilesButton") }}
                    </v-btn>
                  </div>
                </ImageInput>
              </div>
            </div>
          </div>

          <!-- Appearance (Light only) -->
          <div class="section">
            <!-- <div class="section-title-row">
              <v-icon small class="mr-2">fa-regular fa-palette</v-icon>
              <span class="section-title">{{ $t("appearance") }} (Light)</span>
            </div> -->

            <div class="mode-card light">
              <div class="mode-title">{{ $t("light_mode") }}</div>

              <div class="color-row" @click="openColorPicker('primaryLight')">
                <div
                  class="color-chip"
                  :style="{ backgroundColor: colors.primaryLight }"
                ></div>
                <div class="color-meta">
                  <div class="color-name">Primary</div>
                  <div class="color-hex">{{ colors.primaryLight }}</div>
                </div>
              </div>

              <div class="color-row" @click="openColorPicker('secondaryLight')">
                <div
                  class="color-chip"
                  :style="{ backgroundColor: colors.secondaryLight }"
                ></div>
                <div class="color-meta">
                  <div class="color-name">Secondary</div>
                  <div class="color-hex">{{ colors.secondaryLight }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- DARK CARD -->
        <div class="info-card info-card--dark">
          <!-- Partner Logo (Dark) -->
          <div class="section">
            <div class="section-title-row dark">
              <v-icon small class="mr-2">fa-regular fa-palette</v-icon>
              <div class="section-title">{{ $t("appearance") }} (Dark)</div>
            </div>
            <div class="upload-dropzone-dark">
              <div
                class="upload-content"
                @dragover.prevent
                @dragenter.prevent="onDragEnter('DARK')"
                @dragleave.prevent="onDragLeave('DARK')"
                @drop.prevent="onDrop($event, 'DARK')"
                :class="{ dragging: isDraggingDark }"
              >
                <!-- Preview arriba -->
                <div v-if="imagePreviewDark" class="preview-column">
                  <v-img
                    :src="imagePreviewDark"
                    max-height="80"
                    max-width="180"
                    contain
                    class="preview-img"
                  />
                  <v-btn
                    v-if="imagePreviewDark"
                    text
                    small
                    class="remove-btn"
                    @click.stop="removeImage('DARK')"
                  >
                    <v-icon small class="mr-1">fa-regular fa-trash</v-icon>
                    {{ $t("remove") }}
                  </v-btn>
                </div>

                <!-- Empty cuando no hay imagen -->
                <div v-else class="upload-empty">
                  <v-icon size="28" class="mr-2"
                    >fa-regular fa-cloud-arrow-up</v-icon
                  >
                  <div class="upload-text">
                    <div class="upload-title">{{ $t("uploadImage") }}</div>
                    <div class="upload-subtitle">
                      {{ $t("dragDropSelectText") }}
                    </div>
                    <div class="upload-hint">Max: 2MB · JPG/PNG/SVG</div>
                  </div>
                </div>

                <ImageInput
                  v-model="partnerLogoDark"
                  @input="(v) => handleImageChange(v, 'DARK')"
                >
                  <div slot="activator">
                    <v-btn class="browse-btn" depressed>
                      <v-icon small class="mr-2"
                        >fa-regular fa-folder-open</v-icon
                      >
                      {{ $t("browseFilesButton") }}
                    </v-btn>
                  </div>
                </ImageInput>
              </div>
            </div>
          </div>

          <!-- Appearance (Dark only) -->
          <div class="section">
            <!-- <div class="section-title-row">
              <v-icon small class="mr-2">fa-regular fa-palette</v-icon>
              <span class="section-title">{{ $t("appearance") }} (Dark)</span>
            </div> -->

            <div class="mode-card dark">
              <div class="mode-title">{{ $t("dark_mode") }}</div>

              <div class="color-row" @click="openColorPicker('primaryDark')">
                <div
                  class="color-chip"
                  :style="{ backgroundColor: colors.primaryDark }"
                ></div>
                <div class="color-meta">
                  <div class="color-name">Primary</div>
                  <div class="color-hex">{{ colors.primaryDark }}</div>
                </div>
              </div>

              <div class="color-row" @click="openColorPicker('secondaryDark')">
                <div
                  class="color-chip"
                  :style="{ backgroundColor: colors.secondaryDark }"
                ></div>
                <div class="color-meta">
                  <div class="color-name">Secondary</div>
                  <div class="color-hex">{{ colors.secondaryDark }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- RIGHT -->
      <div class="preview-card">
        <div class="preview-header">
          <div class="preview-title">{{ $t("rankingLayout_livePreview") }}</div>
          <div class="preview-subtitle">
            {{ $t("rankingLayout_descrition1") }}
          </div>
        </div>

        <div class="preview-body">
          <!-- SOLO 1 bloque, alterna LIGHT/DARK -->
          <div v-if="previewMode === 'LIGHT'" class="preview-block light">
            <div class="preview-top">
              <v-icon small class="mr-2">fa-regular fa-palette</v-icon>
              <span>{{ $t("appearance") }}</span>
              <v-spacer />

              <span class="mode-caption">{{ $t("seeing_dark") }}</span>

              <!-- ICONO toggle -->
              <button
                class="mode-toggle"
                type="button"
                @click="togglePreviewMode"
              >
                <v-icon small>fa-regular fa-moon</v-icon>
              </button>
            </div>

            <div class="sample">
              <div
                class="sample-header"
                :style="{
                  backgroundColor: colors.primaryLight,
                  color: colors.secondaryLight,
                  '--text-color': colors.secondaryLight,
                }"
              >
                {{ $t("tournamentHeaderSample") }}
              </div>
              <div class="sample-content light-preview">
                <button
                  class="sample-btn"
                  :style="{
                    backgroundColor: colors.primaryLight,
                    color: colors.secondaryLight,
                    '--text-color': colors.secondaryLight,
                  }"
                >
                  {{ $t("primaryButtonSample") }}
                </button>
                <div
                  class="sample-text"
                  :style="{
                    color: colors.secondaryLight,
                    '--text-color': colors.secondaryLight,
                  }"
                >
                  {{ $t("colorPreviewDescription") }}
                </div>
              </div>
            </div>

            <!-- Contrast indicators for Light mode -->
            <!-- <div class="contrast-row" :class="{ 'contrast-met': contrastLightMet }">
              <span class="contrast-label">
                {{ contrastLightMet ? $t('contrastStandardMet') : $t('contrastStandardNotMet') }}
              </span>
              <div class="contrast-indicator">
                <div class="color-circle">
                  <div class="color-half primary" :style="{ backgroundColor: colors.primaryLight }"></div>
                  <div class="color-half secondary" :style="{ backgroundColor: colors.secondaryLight }"></div>
                </div>
                <v-icon v-if="contrastLightMet" small class="check-icon met">fa-solid fa-check</v-icon>
                <v-icon v-else small class="check-icon not-met">fa-solid fa-xmark</v-icon>
                <span class="aa-badge" :class="{ 'met': contrastLightMet, 'not-met': !contrastLightMet }">
                  {{ contrastLightMet ? 'AA' : 'A' }}
                </span>
              </div>
            </div> -->
          </div>

          <div v-else class="preview-block dark">
            <div class="preview-top">
              <v-icon small class="mr-2">fa-regular fa-palette</v-icon>
              <span>{{ $t("appearance") }}</span>
              <v-spacer />

              <span class="mode-caption">{{ $t("seeing_light") }}</span>

              <!-- ICONO toggle -->
              <button
                class="mode-toggle"
                type="button"
                @click="togglePreviewMode"
              >
                <v-icon small>fa-regular fa-sun</v-icon>
              </button>
            </div>

            <div class="sample dark">
              <div
                class="sample-header"
                :style="{
                  backgroundColor: colors.primaryDark,
                  color: colors.secondaryDark,
                  '--text-color': colors.secondaryDark,
                }"
              >
                {{ $t("tournamentHeaderSample") }}
              </div>
              <div class="sample-content dark">
                <button
                  class="sample-btn"
                  :style="{
                    backgroundColor: colors.primaryDark,
                    color: colors.secondaryDark,
                    '--text-color': colors.secondaryDark,
                  }"
                >
                  {{ $t("primaryButtonSample") }}
                </button>
                <div
                  class="sample-text"
                  :style="{
                    color: colors.secondaryDark,
                    '--text-color': colors.secondaryDark,
                  }"
                >
                  {{ $t("colorPreviewDescription") }}
                </div>
              </div>
            </div>

            <!-- Contrast indicators for Dark mode -->
            <!-- <div class="contrast-row" :class="{ 'contrast-met': contrastDarkMet }">
              <span class="contrast-label">
                {{ contrastDarkMet ? $t('contrastStandardMet') : $t('contrastStandardNotMet') }}
              </span>
              <div class="contrast-indicator">
                <div class="color-circle">
                  <div class="color-half primary" :style="{ backgroundColor: colors.primaryDark }"></div>
                  <div class="color-half secondary" :style="{ backgroundColor: colors.secondaryDark }"></div>
                </div>
                <v-icon v-if="contrastDarkMet" small class="check-icon met">fa-solid fa-check</v-icon>
                <v-icon v-else small class="check-icon not-met">fa-solid fa-xmark</v-icon>
                <span class="aa-badge" :class="{ 'met': contrastDarkMet, 'not-met': !contrastDarkMet }">
                  {{ contrastDarkMet ? 'AA' : 'A' }}
                </span>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <!-- Color Picker Overlay -->
    <v-overlay :dark="false" v-model="showColorPicker">
      <ColorPicker
        :initial-color="selectedColorValue"
        @saveColor="saveColor"
        @closeWindow="showColorPicker = false"
      />
    </v-overlay>
  </div>
</template>

<script>
import ColorPicker from "@/components/ColorPicker.vue";
import ImageInput from "@/components/ImageInput.vue";
import Repository from "../../../../repositories/tournament";
import { mapMutations } from "vuex";

export default {
  name: "TournamentBranding",
  components: { ColorPicker, ImageInput },
  props: {
    stepActive: { type: Boolean, required: false },
    setNextBtnDisabled: { type: Function, required: false },
  },
  computed: {
    tournamentSummary() {
      return this.$store.state.tournament;
    },
    contrastLightMet() {
      return this.checkContrastRatio(
        this.colors.primaryLight,
        this.colors.secondaryLight,
      );
    },
    contrastDarkMet() {
      return this.checkContrastRatio(
        this.colors.primaryDark,
        this.colors.secondaryDark,
      );
    },
  },
  data: () => ({
    partnerLogoLight: null,
    partnerLogoDark: null,
    imagePreviewLight: null,
    imagePreviewDark: null,
    previewMode: "LIGHT",

    colors: {
      primaryLight: "#2F80ED",
      primaryDark: "#1F6FE5",
      secondaryLight: "#333333",
      secondaryDark: "#FFFFFF",
    },

    showColorPicker: false,
    selectedColorType: null,
    selectedColorValue: "",

    initialValues: null,
    uploadingImage: false,
    imageUploaded: false,

    isDraggingLight: false,
    isDraggingDark: false,
    _dragCounterLight: 0,
    _dragCounterDark: 0,
  }),
  mounted() {
    if (this.tournamentSummary) {
      this.init();
    }
    // Disable save button initially
    if (this.setNextBtnDisabled) {
      this.setNextBtnDisabled(true);
    }
  },
  watch: {
    tournamentSummary: {
      handler(newVal) {
        if (newVal && !this.initialValues) {
          this.init();
        }
      },
      immediate: true,
    },
    imagePreviewLight() {
      this.checkForChanges();
    },
    imagePreviewDark() {
      this.checkForChanges();
    },
    colors: {
      handler() {
        this.checkForChanges();
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations(["setTournament"]),
    withHash(hex) {
      if (!hex) return hex;
      return hex.startsWith("#") ? hex : `#${hex}`;
    },
    withoutHash(hex) {
      if (!hex) return hex;
      return hex.replace("#", "");
    },

    // WCAG Contrast Ratio calculation methods
    hexToRgb(hex) {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
          }
        : null;
    },

    getLuminance(r, g, b) {
      // Convert RGB to sRGB
      const [rs, gs, bs] = [r, g, b].map((c) => {
        c = c / 255;
        return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
      });
      // Calculate relative luminance
      return 0.2126 * rs + 0.7152 * gs + 0.0722 * bs;
    },

    getContrastRatio(color1, color2) {
      const rgb1 = this.hexToRgb(color1);
      const rgb2 = this.hexToRgb(color2);

      if (!rgb1 || !rgb2) return 1;

      const l1 = this.getLuminance(rgb1.r, rgb1.g, rgb1.b);
      const l2 = this.getLuminance(rgb2.r, rgb2.g, rgb2.b);

      const lighter = Math.max(l1, l2);
      const darker = Math.min(l1, l2);

      return (lighter + 0.05) / (darker + 0.05);
    },

    checkContrastRatio(primaryColor, secondaryColor) {
      const ratio = this.getContrastRatio(primaryColor, secondaryColor);
      // WCAG AA requires 4.5:1 for normal text, 3:1 for large text
      // We use 4.5:1 as the standard for AA compliance
      return ratio >= 4.5;
    },
    onDragEnter(mode) {
      if (mode === "LIGHT") {
        this._dragCounterLight += 1;
        this.isDraggingLight = true;
      } else {
        this._dragCounterDark += 1;
        this.isDraggingDark = true;
      }
    },
    onDragLeave(mode) {
      if (mode === "LIGHT") {
        this._dragCounterLight -= 1;
        if (this._dragCounterLight <= 0) {
          this.isDraggingLight = false;
          this._dragCounterLight = 0;
        }
      } else {
        this._dragCounterDark -= 1;
        if (this._dragCounterDark <= 0) {
          this.isDraggingDark = false;
          this._dragCounterDark = 0;
        }
      }
    },
    onDrop(e, mode) {
      if (mode === "LIGHT") {
        this._dragCounterLight = 0;
        this.isDraggingLight = false;
      } else {
        this._dragCounterDark = 0;
        this.isDraggingDark = false;
      }

      const file = e.dataTransfer?.files?.[0];
      if (!file) return;

      const allowed = ["image/jpeg", "image/png", "image/svg+xml"];
      const maxBytes = 1 * 1024 * 1024;

      if (!allowed.includes(file.type)) {
        this.$emit("save-error", { message: "Only JPG/PNG/SVG are allowed." });
        return;
      }
      if (file.size > maxBytes) {
        this.$emit("save-error", { message: "Max file size is 1MB." });
        return;
      }

      const imageURL = URL.createObjectURL(file);
      const formData = new FormData();
      formData.append("file", file);

      // Mantiene el mismo contrato que usa ImageInput
      const payload = { imageURL, formData, file };

      // IMPORTANTÍSIMO: también actualiza el v-model correcto
      if (mode === "LIGHT") {
        this.partnerLogoLight = payload;
      } else {
        this.partnerLogoDark = payload;
      }

      // Y usa tu handler existente para preview + change detection
      this.handleImageChange(payload, mode);
    },
    async init() {
      if (!this.tournamentSummary?.tournamentId) return;

      try {
        this._isInitializing = true;

        // Limpia previews mientras carga
        this.imagePreviewLight = null;
        this.imagePreviewDark = null;

        const res = await Repository.getTournamentBranding(
          this.tournamentSummary.tournamentId,
        );
        const branding = res?.data || {};

        // Previews (URLs directas)
        this.imagePreviewLight = branding.light?.fullLogo || null;
        this.imagePreviewDark = branding.dark?.fullLogo || null;

        // Colores (vienen sin #)
        if (branding.light) {
          this.colors.primaryLight =
            this.withHash(branding.light.brandPrimary) ||
            this.colors.primaryLight;
          this.colors.secondaryLight =
            this.withHash(branding.light.brandSecondary) ||
            this.colors.secondaryLight;
        }

        if (branding.dark) {
          this.colors.primaryDark =
            this.withHash(branding.dark.brandPrimary) ||
            this.colors.primaryDark;
          this.colors.secondaryDark =
            this.withHash(branding.dark.brandSecondary) ||
            this.colors.secondaryDark;
        }

        // (Opcional) si quieres guardar medalType para mandarlo de vuelta:
        this.lightMedalType = branding.light?.medalType || "NEON";
        this.darkMedalType = branding.dark?.medalType || "DEFAULT";

        this.saveInitialValues();
        this.checkForChanges();
      } catch (e) {
        console.error("Error loading tournament branding:", e);
        this.saveInitialValues();
      } finally {
        this._isInitializing = false;
      }
    },

    saveInitialValues() {
      this.initialValues = {
        imagePreviewLight: this.imagePreviewLight || null,
        imagePreviewDark: this.imagePreviewDark || null,
        primaryLight: this.colors.primaryLight,
        secondaryLight: this.colors.secondaryLight,
        primaryDark: this.colors.primaryDark,
        secondaryDark: this.colors.secondaryDark,
      };
    },

    checkForChanges() {
      if (!this.initialValues) {
        this.setNextBtnDisabled?.(true);
        return;
      }

      const hasChanges =
        this.imagePreviewLight !== this.initialValues.imagePreviewLight ||
        this.imagePreviewDark !== this.initialValues.imagePreviewDark ||
        this.colors.primaryLight !== this.initialValues.primaryLight ||
        this.colors.secondaryLight !== this.initialValues.secondaryLight ||
        this.colors.primaryDark !== this.initialValues.primaryDark ||
        this.colors.secondaryDark !== this.initialValues.secondaryDark;

      this.setNextBtnDisabled?.(!hasChanges);
    },

    darkenColor(color, amount) {
      // Simple function to darken a color by a percentage
      // Remove # if present
      const hex = color.replace("#", "");
      const num = parseInt(hex, 16);
      const r = Math.max(0, Math.floor((num >> 16) * (1 - amount)));
      const g = Math.max(0, Math.floor(((num >> 8) & 0x00ff) * (1 - amount)));
      const b = Math.max(0, Math.floor((num & 0x0000ff) * (1 - amount)));
      return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, "0")}`;
    },

    togglePreviewMode() {
      this.previewMode = this.previewMode === "LIGHT" ? "DARK" : "LIGHT";
    },

    handleImageChange(imageData, mode) {
      const file = imageData?.file || imageData?.formData?.get?.("file");
      if (file) {
        const allowed = ["image/jpeg", "image/png", "image/svg+xml"];
        const maxBytes = 1 * 1024 * 1024;

        if (!allowed.includes(file.type)) {
          this.$emit("save-error", {
            message: "Only JPG/PNG/SVG are allowed.",
          });
          return;
        }
        if (file.size > maxBytes) {
          this.$emit("save-error", { message: "Max file size is 1MB." });
          return;
        }
      }
      if (mode === "LIGHT") {
        this.partnerLogoLight = imageData;
        if (imageData?.imageURL) {
          this.imagePreviewLight = imageData.imageURL;
        }
      }

      if (mode === "DARK") {
        this.partnerLogoDark = imageData;
        if (imageData?.imageURL) {
          this.imagePreviewDark = imageData.imageURL;
        }
      }

      this.checkForChanges();
    },
    removeImage(mode) {
      if (mode === "LIGHT") {
        this.partnerLogoLight = null;
        this.imagePreviewLight = null;
      } else {
        this.partnerLogoDark = null;
        this.imagePreviewDark = null;
      }

      this.imageUploaded = false;
      this.checkForChanges();
    },

    openColorPicker(type) {
      this.selectedColorType = type;
      this.selectedColorValue = (this.colors[type] || "#009F63").replace(
        "#",
        "",
      );
      this.showColorPicker = true;
    },
    saveColor(color) {
      if (this.selectedColorType) {
        this.$set(
          this.colors,
          this.selectedColorType,
          color.startsWith("#") ? color : `#${color}`,
        );
      }
      this.showColorPicker = false;
      this.checkForChanges();
    },

    saveTournamentSettings() {
      // Validate that tournament exists in store
      if (!this.tournamentSummary || !this.tournamentSummary.tournamentId) {
        this.$emit("save-error", {
          message:
            this.$t("alerts.errorOccurred") || "Tournament data not available",
        });
        return;
      }

      // Use the new edit-branding endpoint which handles image and colors together
      this.saveTournamentBranding();
    },

    saveTournamentBranding() {
      const formData = new FormData();

      // --- Helpers ---
      const extractFile = (img) => {
        if (!img) return null;
        if (img.file instanceof Blob) return img.file; // File o Blob
        const fdFile = img.formData?.get?.("file");
        if (fdFile instanceof Blob) return fdFile;
        return null;
      };

      const toNamedFile = (file, fallbackName) => {
        if (!file) return null;

        if (file instanceof File && file.name) return file;

        if (file instanceof Blob) {
          return new File([file], fallbackName, {
            type: file.type || "application/octet-stream",
          });
        }

        return null;
      };

      // ========================
      // LIGHT
      // ========================
      formData.append("light.type", "LIGHT");
      formData.append("light.medalType", "NEON");
      formData.append(
        "light.brandPrimary",
        this.colors.primaryLight.replace("#", ""),
      );
      formData.append(
        "light.brandSecondary",
        this.colors.secondaryLight.replace("#", ""),
      );

      const rawLight = extractFile(this.partnerLogoLight);
      const lightFile = toNamedFile(rawLight, "light-logo.png");
      if (lightFile) {
        formData.append("light.image", lightFile, lightFile.name);
      }

      // ========================
      // DARK
      // ========================
      formData.append("dark.type", "DARK");
      formData.append("dark.medalType", "DEFAULT");
      formData.append(
        "dark.brandPrimary",
        this.colors.primaryDark.replace("#", ""),
      );
      formData.append(
        "dark.brandSecondary",
        this.colors.secondaryDark.replace("#", ""),
      );

      const rawDark = extractFile(this.partnerLogoDark);
      const darkFile = toNamedFile(rawDark, "dark-logo.png");
      if (darkFile) {
        formData.append("dark.image", darkFile, darkFile.name);
      }

      for (const [k, v] of formData.entries()) {
        if (v instanceof File) console.log(k, v.name, v.type, v.size);
        else console.log(k, v);
      }

      // ========================
      // CALL BULK ENDPOINT
      // ========================
      Repository.editTournamentBrandingBulk(
        this.tournamentSummary.tournamentId,
        formData,
      )
        .then((response) => {
          if (response.status < 400) {
            this.init(); // recarga branding
            this.setNextBtnDisabled?.(true);

            this.$emit("save-success", {
              message: "Branding updated successfully",
            });
          } else {
            this.$emit("save-error", {
              message: "Error updating branding",
            });
          }
        })
        .catch((error) => {
          this.$emit("save-error", {
            message: error.response?.data?.message || "Error updating branding",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.tournament-branding {
  width: 100%;
  font-family: "Avenir", sans-serif;

  .title {
    font-size: 32px !important;
    font-weight: bold;
    margin-bottom: 8px;
    color: var(--v-textPrimary-base);
  }
  .subtitle {
    font-size: 16px;
    color: var(--v-textSecondary-base);
    margin-bottom: 24px;
  }
}

.branding-layout {
  display: grid;
  grid-template-columns: 1.6fr 1fr;
  gap: 24px;
  align-items: stretch;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
}

.info-card {
  background-color: var(--v-cardBackground-base);
  border: 1px solid #ededed;
  border-radius: 10px;
  padding: 28px;
  position: relative;
}
.theme--dark .info-card {
  border-color: #424242;
}

.section {
  margin-bottom: 22px;
}

.section-title-row {
  display: flex;
  align-items: center;
  margin-bottom: 12px;

  .section-title {
    font-weight: 600;
  }
}

.theme--dark .section-title-row .section-title {
  color: var(--v-fullWhite-base) !important;
}

.theme--dark .section-title-row .v-icon {
  color: var(--v-fullWhite-base) !important;
}

.upload-dropzone {
  border: 2px dashed #d9d9d9;
  border-radius: 10px;
  padding: 16px;
  background: #fafafa;
  transition: all 0.3s ease;
}

.upload-dropzone-dark {
  border: 2px dashed #d9d9d9;
  border-radius: 10px;
  padding: 16px;
  background: #232830;
  transition: all 0.3s ease;
}

.theme--dark .upload-dropzone {
  border-color: #424242;
  background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%);
}

.upload-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  text-align: center;
}

.theme--dark .upload-empty {
  color: var(--v-mainWhite);
}

.theme--dark .upload-title {
  color: var(--v-mainWhite);
}

.theme--dark .upload-subtitle {
  color: rgba(255, 255, 255, 0.7);
}

.theme--dark .upload-hint {
  color: rgba(255, 255, 255, 0.6);
}

.theme--dark .upload-empty .v-icon {
  color: rgba(255, 255, 255, 0.7);
}

.preview-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.preview-img {
  border-radius: 8px;
  border: 1px solid #e6e6e6;
}

.theme--dark .preview-img {
  border-color: #9a9a9a;
}

.browse-btn {
  background: var(--v-mainGreen-base) !important;
  color: white !important;
  border-radius: 8px !important;
  height: 36px;
}

.appearance-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
}

.mode-card {
  border-radius: 10px;
  padding: 14px;
  border: 1px solid #e6e6e6;

  .mode-title {
    font-weight: 600;
    font-size: 12px;
    margin-bottom: 10px;
    opacity: 0.9;
    color: var(--v-mainBlack-base);
  }

  &.dark {
    background: #232830;
    color: #fff;
    border-color: #fff;

    .mode-title {
      color: #fff !important;
      opacity: 1 !important;
    }

    .color-name {
      color: #fff !important;
    }

    .color-hex {
      color: rgba(255, 255, 255, 0.8) !important;
    }
  }
}

.theme--dark .mode-card {
  border-color: #424242;
  background: var(--v-cardBackground-base);
}

.theme--dark .mode-card .mode-title {
  color: var(--v-fullWhite-base) !important;
  opacity: 1 !important;
  font-weight: 600;
}

.theme--dark .mode-card .color-name {
  color: var(--v-fullWhite-base) !important;
  font-weight: 600;
}

.theme--dark .mode-card .color-hex {
  color: rgba(255, 255, 255, 0.8) !important;
}

.color-row {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 10px;
  border-radius: 8px;

  &:hover {
    background: rgba(0, 0, 0, 0.04);
  }

  .color-chip {
    width: 26px;
    height: 26px;
    border-radius: 6px;
    border: 1px solid rgba(0, 0, 0, 0.1);
  }

  .color-meta {
    display: flex;
    flex-direction: column;
    line-height: 1.1;
  }

  .color-name {
    font-size: 12px;
    font-weight: 600;
    color: var(--v-mainBlack-base);
  }

  .color-hex {
    font-size: 11px;
    opacity: 0.7;
    color: var(--v-mainBlack-base);
  }
}

.mode-card.dark {
  .color-name {
    color: #fff !important;
  }

  .color-hex {
    color: rgba(255, 255, 255, 0.8) !important;
    opacity: 1 !important;
  }
}

.theme--dark .color-row:hover {
  background: rgba(255, 255, 255, 0.08);
}

.preview-card {
  height: 100%;
  min-height: 640px;
  display: flex;
  flex-direction: column;
  border: 1px solid #e6e6e6;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;

  .preview-header {
    padding: 18px;
    text-align: center;
    border-bottom: 1px solid #eee;

    .preview-title {
      font-family: "Aeonik", "Avenir", sans-serif !important;
      font-size: 30px;
      font-weight: 800;
      color: var(--v-textPrimary-base);
    }
    .preview-subtitle {
      font-size: 12px;
      color: var(--v-textSecondary-base);
    }
  }

  .preview-body {
    padding: 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
  }
}

.theme--dark .preview-card {
  border-color: #424242;
  background: var(--v-cardBackground-base);
}

.theme--dark .preview-card .preview-header {
  border-bottom-color: #424242;
}

.theme--dark .preview-card .preview-title {
  color: var(--v-fullWhite-base) !important;
  font-weight: 700;
}

.theme--dark .preview-card .preview-subtitle {
  color: rgba(255, 255, 255, 0.8) !important;
}

.preview-block {
  border-radius: 14px;
  border: 1px solid #eee;
  padding: 24px;

  &.dark {
    background: #3a424d;
    color: #fff;
    border-color: #3a424d;

    .preview-top {
      color: #fff !important;
      opacity: 1 !important;

      .v-icon {
        color: #fff !important;
        opacity: 1 !important;
      }

      span {
        color: #fff !important;
        opacity: 1 !important;
      }
    }

    .mode-caption {
      color: #fff !important;
      opacity: 1 !important;
    }
  }

  .preview-top {
    display: flex;
    align-items: center;
    font-size: 12px;
    opacity: 0.9;
    margin-bottom: 10px;
    color: var(--v-mainBlack-base);

    > span {
      color: var(--v-mainBlack-base);
    }
  }

  .mode-caption {
    font-size: 11px;
    opacity: 0.7;
    color: var(--v-mainBlack-base);
  }
}

.theme--dark .preview-block {
  border-color: #424242;
}

.theme--dark .preview-block .preview-top {
  color: var(--v-fullWhite-base) !important;
  opacity: 1 !important;
}

.theme--dark .preview-block .mode-caption {
  color: var(--v-fullWhite-base) !important;
  opacity: 1 !important;
}

.theme--dark .preview-block .preview-top .v-icon {
  color: var(--v-fullWhite-base) !important;
  opacity: 1 !important;
}

.theme--dark .preview-block .preview-top span {
  color: var(--v-fullWhite-base) !important;
  opacity: 1 !important;
}

.preview-block.dark .preview-top {
  color: #fff !important;
  opacity: 1 !important;
}

.preview-block.dark .preview-top .v-icon {
  color: #fff !important;
  opacity: 1 !important;
}

.preview-block.dark .preview-top > span:not(.mode-caption) {
  color: #fff !important;
  opacity: 1 !important;
  -webkit-text-fill-color: #fff !important;
}

.preview-block.dark .preview-top span.mode-caption {
  color: #fff !important;
  opacity: 1 !important;
  -webkit-text-fill-color: #fff !important;
}

.preview-block.dark .mode-caption {
  color: #fff !important;
  opacity: 1 !important;
  -webkit-text-fill-color: #fff !important;
}

.mode-toggle {
  border: 0;
  background: transparent;
  cursor: pointer;
  padding: 6px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: rgba(0, 0, 0, 0.06);
  }

  .v-icon {
    color: var(--v-mainBlack-base);
  }
}

.theme--dark .mode-toggle {
  .v-icon {
    color: var(--v-fullWhite-base) !important;
    opacity: 1 !important;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
}

.preview-block.dark .mode-toggle {
  .v-icon {
    color: #fff !important;
    opacity: 1 !important;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
}

.preview-block.dark {
  .mode-toggle:hover {
    background: rgba(255, 255, 255, 0.1);
  }
}

.sample {
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #eee;

  .sample-header {
    padding: 10px;
    font-weight: 600;
    text-align: center;
    font-size: 12px;
  }

  .sample-content {
    padding: 12px;
    background: #fff;
    text-align: center;

    &.dark {
      background: #2d3540;
    }
  }

  .sample-btn {
    border: none;
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    margin-bottom: 8px;
    cursor: default;
  }

  .sample-text {
    font-size: 11px;
  }
}

/* Preview block LIGHT mode - force light styles even when global theme is dark */
.preview-block.light {
  background: #fff;
  border-color: #eee;

  .preview-top {
    color: #333 !important;

    .v-icon {
      color: #333 !important;
    }

    span {
      color: #333 !important;
    }
  }

  .mode-caption {
    color: #333 !important;
  }

  .mode-toggle .v-icon {
    color: #333 !important;
  }

  .sample {
    border-color: #eee !important;

    .sample-content {
      background: #fff !important;
    }
  }
}

/* When global theme is dark, preview-block.light still needs light styles */
.theme--dark .preview-block.light {
  background: #fff;
  border-color: #eee;

  .preview-top {
    color: #333 !important;
    -webkit-text-fill-color: #333 !important;

    .v-icon {
      color: #333 !important;
      -webkit-text-fill-color: #333 !important;
    }

    span {
      color: #333 !important;
      -webkit-text-fill-color: #333 !important;
    }
  }

  .mode-caption {
    color: #333 !important;
    -webkit-text-fill-color: #333 !important;
  }

  .mode-toggle .v-icon {
    color: #333 !important;
    -webkit-text-fill-color: #333 !important;
  }

  .sample {
    border-color: #eee !important;

    .sample-content {
      background: #fff !important;

      &.light-preview {
        .sample-btn {
          color: var(--text-color, #333) !important;
          -webkit-text-fill-color: var(--text-color, #333) !important;
        }

        .sample-text {
          color: var(--text-color, #333) !important;
          -webkit-text-fill-color: var(--text-color, #333) !important;
        }
      }
    }

    .sample-header {
      color: var(--text-color, #fff) !important;
      -webkit-text-fill-color: var(--text-color, #fff) !important;
    }

    .sample-btn {
      color: var(--text-color, #fff) !important;
      -webkit-text-fill-color: var(--text-color, #fff) !important;
    }

    .sample-text {
      color: var(--text-color, #333) !important;
      -webkit-text-fill-color: var(--text-color, #333) !important;
    }
  }
}

/* Contrast indicator styles */
.contrast-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
  padding: 12px 14px;
  border-radius: 10px;
  background: #f5f5f5;
  border: 1px solid #e0e0e0;

  .contrast-label {
    font-size: 12px;
    font-weight: 500;
    color: #666;
  }

  .contrast-indicator {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .color-circle {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    border: 1px solid rgba(0, 0, 0, 0.1);

    .color-half {
      width: 50%;
      height: 100%;

      &.primary {
        border-radius: 12px 0 0 12px;
      }

      &.secondary {
        border-radius: 0 12px 12px 0;
      }
    }
  }

  .check-icon {
    font-size: 14px;

    &.met {
      color: #28ea96 !important;
    }

    &.not-met {
      color: #f44336 !important;
    }
  }

  .aa-badge {
    font-size: 11px;
    font-weight: 700;
    padding: 2px 6px;
    border-radius: 4px;

    &.met {
      background: #28ea96;
      color: #fff;
    }

    &.not-met {
      background: #f44336;
      color: #fff;
    }
  }
}

/* Dark mode preview contrast row */
.preview-block.dark .contrast-row {
  background: #2d3540;
  border-color: #424242;

  .contrast-label {
    color: rgba(255, 255, 255, 0.8);
  }
}

/* Light mode preview contrast row when global theme is dark */
.preview-block.light .contrast-row {
  background: #f5f5f5;
  border-color: #e0e0e0;

  .contrast-label {
    color: #666;
  }
}

.theme--dark .preview-block.light .contrast-row {
  background: #f5f5f5;
  border-color: #e0e0e0;

  .contrast-label {
    color: #666;
  }
}

.theme--light .tournament-branding {
  --disabled-bg: #f5f5f5;
  --disabled-border: #e0e0e0;
  --disabled-text: #9e9e9e;
  --disabled-icon: #9e9e9e;
}

.theme--dark .tournament-branding {
  --disabled-bg: rgba(255, 255, 255, 0.06);
  --disabled-border: rgba(255, 255, 255, 0.14);
  --disabled-text: rgba(255, 255, 255, 0.55);
  --disabled-icon: rgba(255, 255, 255, 0.45);
}

::v-deep .v-input--is-disabled .v-input__control .v-input__slot {
  background-color: var(--disabled-bg) !important;
  border-color: var(--disabled-border) !important;
}

::v-deep .v-input--is-disabled input,
::v-deep .v-input--is-disabled textarea {
  color: var(--disabled-text) !important;
  -webkit-text-fill-color: var(--disabled-text) !important;
}

::v-deep .v-input--is-disabled .v-label {
  color: var(--disabled-text) !important;
}

::v-deep .v-input--is-disabled .v-select__selection {
  color: var(--disabled-text) !important;
}

::v-deep .v-input--is-disabled .v-icon {
  color: var(--disabled-icon) !important;
}

::v-deep
  .v-input--is-disabled
  .v-input__details
  .v-messages
  .v-messages__message {
  color: var(--disabled-text) !important;
}

::v-deep .v-input--is-disabled .v-input__details .v-counter {
  color: var(--disabled-text) !important;
}

.upload-content.dragging {
  border-radius: 10px;
  outline: 2px solid var(--v-mainGreen-base);
  outline-offset: 4px;
}

.info-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  align-items: stretch;
  width: 100%;
}

/* opcional: que ambas queden con la misma altura visual */
.info-card {
  width: 100%;
}

/* opcional: pequeños detalles por tipo */
.info-card--dark {
  background: #232830;
  color: white !important;
}

.info-card--light {
  /* idem */
}

.appearance-row {
  display: grid;
  grid-template-rows: 1fr 1fr;
}

.mode-card.dark .color-row:hover {
  background: rgba(255, 255, 255, 0.08);
}

.preview-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.buttons-row {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
}

::v-deep .info-card--dark .section .section-title-row .theme--light.v-icon {
  color: white !important;
}
</style>
